module.exports = __webpack_public_path__ + "static/media/baggage.ee64306c.svg";